import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, deepClone } from '../utils'
import BeenhereIcon from '@mui/icons-material/Beenhere';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import Loading from './Loading';
import { useDispatch, useSelector } from 'react-redux';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { redNex } from '../Redux/nexSlice';

function MobileSupportTest({ nexListn, _nex }) {
    const [data, setData] = useState([])
    const [url, setUrl] = useState('')
    const [originalUrl, setOriginalUrl] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const [noInput1, setNoInput1] = useState(false)

    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)

    const dispatch = useDispatch()

    const getData = async () => {
        if(url !== '') {
          setNoInput1(false)

          const updateAnalytics = async () => {
            const tool = window.location.pathname.split('/').pop();
            let tools = deepClone(user.analytics.toolsUsage);
        
            if (isNaN(tools[tool]) || tools[tool] == 'NaN') {
                tools[tool] = 1;
            } else {
                tools[tool] = Number(tools[tool]) + 1;
            }
        
            await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
        };


            setIsLoading(true)
            fetch(`${base}/res`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                type: 'mst',
                url: url,
                userId: user.id
              })
            }).then(res=> res.json()).then(data=> {
              setData(data)
              setOriginalUrl(url)
              setIsLoading(false)
              dispatch(redNex(nx))
              updateAnalytics()
            })
          } else {
            if(url.trim() === '') setNoInput1(true)
          }
    }

  

  return (
    <MobileSupportTestContainer>
        <MobileSupportTestInputContainer>
                <h2>Mobile Support Test <span style={{fontSize: 'medium', marginLeft: '20px'}}></span></h2>
                <MobileSupportTestInputInnerContainer>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Enter Website</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', borderColor: noInput1? 'red': '', color: '#1eb277'}} value={url} onChange={e=> setUrl(e.target.value)}/></div>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Run Test': 'Running Test ...'}</button>}
                {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
                </MobileSupportTestInputInnerContainer>
        </MobileSupportTestInputContainer>

        {data.length !== 0 && !isLoading && <MobileSupportTestResContainer>
            <MobileSupportTestRes>
                {data[0].img?.match(/([^/]+)(?=\.\w+$)/)[1] === 'check128'? <BeenhereIcon style={{color: 'var(--tst-color)'}}/>: <DisabledByDefaultIcon style={{color: 'red'}}/>}
                <h3 style={{color: data[0].img?.match(/([^/]+)(?=\.\w+$)/)[1] === 'check128'? 'green': 'red'}}>{data[0].msg.replace('This website', originalUrl)}</h3>
            </MobileSupportTestRes>
            <div style={{overflowX: 'hidden', overflowY: 'scroll'}}>
            <TestRes style={{border: 'none', marginTop: '30px'}}>
                        <p style={{width: '100px', color: 'gray'}}>Type</p>
                        <p style={{width: '600px', color: 'gray'}}>Information</p>
                        <p style={{color: 'gray'}}>Mobile</p>
            </TestRes>
            {data[0].ms.map(res=> {
                return (
                    <TestRes>
                        <p style={{width: '100px'}}>{res.type}</p>
                        <p style={{width: '600px'}}>{res.info}</p>
                        <p>{res.mobile.match(/([^/]+)(?=\.\w+$)/)[1] === 'check32'? <CheckCircleIcon style={{color: 'var(--tst-color)'}}/>: <DisabledByDefaultIcon style={{color: 'red'}} />}</p>
                    </TestRes>
                )
            })}</div>
        </MobileSupportTestResContainer>}
        {isLoading && <Loading />}

        {data.length == 0 && !isLoading && <Intro>

          <h3>Tool Overview</h3>
          <br />
          <p>
            The Mobile Support Test Tool evaluates how well your website performs on mobile devices. 
            It checks for responsiveness and usability issues to ensure that your site provides a seamless experience for mobile users, which is crucial for both user satisfaction and SEO.
          </p>
          <br /><br />
          
          <h3>Instructions</h3>
          <br />
          <p>1. Enter your website URL in the search bar</p>
          <p>2. Click "Run Test" to analyze your site’s mobile compatibility</p>
          <br /><br />
          
          <h3>Tips</h3>
          <br />
          <p>Ensure your site is fully responsive and loads efficiently on mobile devices to improve user experience and search engine rankings</p>

        </Intro>}
    </MobileSupportTestContainer>
  )
}

export default MobileSupportTest


const MobileSupportTestContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const MobileSupportTestInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--tst-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--tst-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--tst-color);
    color: white;
  }

  > div > button:hover {
    color: var(--tst-color);
    background-color: rgb(239, 239, 239);
  }
`


const MobileSupportTestInputInnerContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--tst-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }
`


const MobileSupportTestResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;
`


const MobileSupportTestRes = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 20px;

    > .MuiSvgIcon-root {
        font-size: 60px;
    }

    > h3 {
        font-weight: 300;
        margin-left: 30px;
    }
`


const TestRes = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);
    justify-content: space-between;


    > p {
        display: flex;
        align-items: center;
    }
`


const NoConnection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-block: 60px;
    background: repeating-linear-gradient(-45deg, var(--tst-color), #00800027 33.33%, #ffffff 33.33%, #ffffff 66.66%);


    > p {
        font-size: large;
        color: var(--tst-color);
    }

    > p > span {
        color: gray;
    }
`


const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`